import _ from 'lodash';
import { DEFAULT_TAG_WEIGHT, STATEMENT_SCORE_LIMIT } from '../config/const';

export default {
  stringToClass (str) {
    return this.checkString(str) ? this.replaceSpecialCharacters(str.replace(/ /gm, '-'), '/','').trim().toLowerCase() : str;
  },

  checkString(str){
    return _.isString(str) && str.length > 0;
  },

  replaceSpecialCharacters(str){
    //Had to forcefully disable eslint as it was not recognising pattern to be a regex
    /*eslint-disable */
    var pattern = /[§`~!@#$%^&*()_|+\-=?;:'",.<>{}\[\]\\\/]/gi;
    /*eslint-enable */
    return this.checkString(str) ? str.replace(pattern, '') : str;
  },

  getTagScore(tag, positive) {
    const score = positive ? tag.positive_score || 0 : tag.negative_score || 0;
    //return score * (tag.weight && tag.weight <= STATEMENT_SCORE_LIMIT ? tag.weight : DEFAULT_TAG_WEIGHT);
    return score;
  },

  hexToRgba (value, alpha = 1) {
    if (!value) return '';
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(value);
    return result ? `rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, ${alpha})` : false;
  },

  getShortcutAsString (shortcutKeys, stringSeparator = ' + ') {
    let string = '';
    
    shortcutKeys = _.sortBy(shortcutKeys, ['order']);

    shortcutKeys.map((shortcut, i) => {
      const separator = shortcutKeys.length > i+1 ? stringSeparator : '';
      string += shortcut.key + separator;
    });
    return string;
  },

  getRelativePathFromAbsolute(absolutePath){
    const url = new URL(absolutePath);
    return `${url.pathname}${url.search}`.trim();
  },

  getPathFromSearch(projectId, search) {
    const base = `/analysis/projects/${projectId}`;
    const params = new URLSearchParams(search);

    let path = "";

    // Check if origin is set, if so we already know which page we want.
    // Otherwise go to main articles list.
    if (search.indexOf('origin') > -1) {
      const origin = params.get('origin');
      if (origin === 'coder-articles') {
        path = `/coders/${params.get('coder_id[0][value]')}/articles`;
      } else if (origin === 'tag-articles') {
        path = `/tags/${params.get('tag_id[0][value]')}/articles`;
      } else if (origin === 'author-articles') {
        path = `/authors/${params.get('author_id[0][value]')}/articles`;
      } else if (origin === 'group-articles') {
        path = `/groups/${params.get('group_id')}/articles`;
      } else if (origin === 'source-articles') {
        path = `/sources/${params.get('source_id')}/articles`;
      }
    }

    params.delete('page');
    params.delete('per_page');
    params.delete('project_id');
    params.append('page', '1');

    const url = base + path + '/?' + params.toString();
    return url;
  }
}